/**
 * 글로벌하게 사용하는 간단한 것만 추가
 */
const globalUtil = {
    /**
     * 로컬 개발 환경인지 확인
     * @returns
     */
    $debugIsLocalhost: () => window.location.host === 'localhost:5090',
};
export default {
    install(Vue) {
        Object.keys(globalUtil).forEach((key) => {
            // eslint-disable-next-line no-param-reassign
            Vue.config.globalProperties[key] = globalUtil[key];
            // composition setup 용
            Vue.provide(key, globalUtil[key]);
        });
    },
};
